import JSZip from 'jszip';
import { saveAs } from 'file-saver'; // 用于触发文件下载

export function svgDownload(svgString, fileName = "ailogo") {
    // 创建 JSZip 实例
    const zip = new JSZip();

    // 添加 SVG 文件到 ZIP
    zip.file(`${fileName}.svg`, svgString);

    // 添加说明文件到 ZIP
    zip.file("SVG矢量图片文件说明.txt", "注意！！！ 点击SVG文件后，浏览器直接打开SVG文件预览是正常操作！！！\n" +
        "\n" +
        "SVG 是将图像描述为形状、路径、文本和滤镜效果的矢量格式。生成的文件可以在网络、印刷甚至资源受限的手持设备上提供高质量的图形。\n" +
        "\n" +
        "使用Adobe Illustrator、Coral Draw、Sketch、Affinity Designer等软件可以查看和编辑svg文件，还能导出保存为svg或其他格式的文件。\n" +
        "\t\t\t\t\n" +
        "注，Adobe Photoshop不支持编辑svg文件，请更换矢量图设计软件。");

    // 生成 ZIP 文件并触发下载
    zip.generateAsync({ type: "blob" })
        .then((content) => {
            // 使用 file-saver 触发下载
            saveAs(content, `${fileName}.zip`);
        })
        .catch((error) => {
            console.error("ZIP 文件生成失败:", error);
        });
}